/* eslint-disable @next/next/no-img-element */
import React from 'react'
import styles from './styles.module.scss'
import Image from 'next/image'
import Link from 'next/link'
import { listItemRoute } from 'src/consts'

export type ListProps = {
  data?: object
}
const truncateTitle = (title, wordCount) => {
  const words = title.split(' ')
  const truncatedTitle = words.slice(0, wordCount).join(' ')
  return truncatedTitle + (words.length > wordCount ? '...' : '')
}

export const List = ({ data }: ListProps) => {
  const flatData = Object.values(data).flat()

  const calculateOverallRating = ratings => {
    const totalScore = ratings.reduce((acc, rating) => acc + rating.score, 0)
    const overallRating = totalScore / ratings.length
    return overallRating.toFixed(1) // Adjust the decimal places as needed
  }

  //color of the star depending on the rating
  const getStarIconPath = overallRating => {
    let starImagePath = '/assets/icons/icon-star-green.svg' // Default color

    if (overallRating >= 1 && overallRating <= 3.9) {
      starImagePath = '/assets/icons/icon-star-rating-darkred.svg'
    } else if (overallRating >= 4 && overallRating <= 6.9) {
      starImagePath = '/assets/icons/icon-star-rating-red.svg'
    } else if (overallRating >= 7 && overallRating <= 9.9) {
      starImagePath = '/assets/icons/icon-star-green.svg'
    } else if (overallRating >= 10) {
      starImagePath = '/assets/icons/icon-star-rating-darkgreen.svg'
    }

    return starImagePath
  }

  //color of the rating depending on the rating
  const getRatingColor = overallRating => {
    let ratingColor = '#52AD53' // Default color

    if (overallRating >= 1 && overallRating <= 3.9) {
      ratingColor = '#EA5C5C'
    } else if (overallRating >= 4 && overallRating <= 6.9) {
      ratingColor = '#F38181'
    } else if (overallRating >= 7 && overallRating <= 9.9) {
      ratingColor = '#7CC07C'
    }

    return ratingColor
  }

  return (
    <div className={styles.container}>
      <div className={styles.itemsContainer}>
        <div className={styles.list}>
          {flatData.map((item: any, index: number) => {
            return (
              <Link
                key={index}
                href={listItemRoute({ itemSlug: item.slug })}
                legacyBehavior
              >
                <a className={styles.reviewContainer}>
                  <div className={styles.mobileContainer}>
                    <div className={styles.imgContainer}>
                      <Image
                        src={item.thumbnail}
                        alt='thumbnail'
                        className={styles.img}
                        style={{ objectFit: 'cover' }}
                        height={150}
                        width={150}
                      />
                    </div>
                    <div className={styles.mobileTitle}>
                      <h3>{truncateTitle(item.title, 3)}</h3>
                      <div className={styles.mobileRating}>
                        <div className={styles.overallRating}>
                          <Image
                            src={getStarIconPath(
                              calculateOverallRating(item.rating)
                            )}
                            height={15}
                            width={15}
                            alt='colored-star'
                          />
                          <span
                            style={{
                              color: getRatingColor(
                                calculateOverallRating(item.rating)
                              ),
                            }}
                          >
                            {calculateOverallRating(item.rating)}
                          </span>
                        </div>
                        <div className={styles.category}>{item.category}</div>
                      </div>
                    </div>
                  </div>
                  <div className={styles.contentContainer}>
                    <div className={styles.title}>
                      <h3>{truncateTitle(item.title, 3)}</h3>
                      {item.rating && item.rating.length > 0 && (
                        <div className={styles.overallRating}>
                          <Image
                            src={getStarIconPath(
                              calculateOverallRating(item.rating)
                            )}
                            height={15}
                            width={15}
                            alt='colored-star'
                          />
                          <span
                            style={{
                              color: getRatingColor(
                                calculateOverallRating(item.rating)
                              ),
                            }}
                          >
                            {calculateOverallRating(item.rating)}
                          </span>
                        </div>
                      )}
                      <div className={styles.category}>{item.category}</div>
                      <img
                        src={item.image} // Use the image URL from your data
                        alt='thumbnail'
                        className={styles.img}
                        style={{ objectFit: 'cover', height: 25, width: 25 }}
                      />
                    </div>
                    <div className={styles.teaser}>
                      <p
                        dangerouslySetInnerHTML={{ __html: item.shortPreview }}
                      />
                    </div>
                  </div>
                </a>
              </Link>
            )
          })}
        </div>
      </div>
    </div>
  )
}
